import React from "react";
import InformationTooltip from "../Tooltips/InformationTooltip";

const CheckBox = ({
    name,
    checked,
    onChangeHandler,
    label,
    containerClassName = "",
    labelClassName = "",
    checkBoxClassName = "",
    disabled,
    disabledLabelMessage,
    isIntermediate,
    includeTextInput,
}) => {
    return (
        <div className={`flex flex-row ${containerClassName}`}>
            <div
                className={`checkbox-wrapper-input ${
                    includeTextInput ? "self-end !h-auto" : ""
                } ${isIntermediate ? "intermediate" : ""} ${
                    disabled ? "disabled" : ""
                }`}
            >
                <input
                    type="checkbox"
                    className="checkbox-element"
                    name={name}
                    id={`checkbox-option-${name}-header`}
                    checked={checked ?? false}
                    disabled={disabled}
                    onChange={onChangeHandler}
                />
                <label
                    htmlFor={`checkbox-option-${name}-header`}
                    className={checkBoxClassName}
                ></label>
            </div>
            <span className="flex gap-1">
                <span
                    className={`${labelClassName} ${
                        disabled ? "disabled" : ""
                    } text-secondary-color-light-blue span-label w-full `}
                >
                    <span>{label}</span>
                </span>
                {disabled && disabledLabelMessage && (
                    <InformationTooltip message={disabledLabelMessage} />
                )}
            </span>
        </div>
    );
};

export default CheckBox;
